import React from 'react';
import moment from 'moment';
import URL from 'url-parse';
import { Tooltip } from 'components';
import { Video } from 'components';
import * as styles from './PostPlatformPreview.scss';

function TwitterPreview(props) {
  var account = props.account,
      images = props.images,
      link = props.link,
      linkDescription = props.linkDescription,
      linkTitle = props.linkTitle,
      message = props.message,
      postDate = props.postDate,
      videos = props.videos;
  var m = message && message.replace(/\s+/g, '') ? /*#__PURE__*/React.createElement("span", {
    className: styles.tw_post_content
  }, message) : /*#__PURE__*/React.createElement("span", {
    className: styles.tw_post_content
  }, /*#__PURE__*/React.createElement("i", null, "Type a message to see the preview here."));
  var accountInfo = {
    profileImage: 'https://s3.amazonaws.com/likeabucket/user_upload/232/-M3b2fGE6.jpeg',
    profileName: /*#__PURE__*/React.createElement("h3", null, "Username ", /*#__PURE__*/React.createElement(Tooltip, {
      name: "missing_twitter_account",
      message: "You do not have an X (Twitter) account connected."
    })),
    profileUsername: '@username'
  };

  if (account) {
    accountInfo.profileImage = account.avatarImageUrl;
    accountInfo.profileName = account.username;
    accountInfo.profileUsername = "@".concat(account.username);
  }

  if (!link) {
    var imgList = images || [];
    var videoList = [];

    if (videos && videos.length > 0) {
      imgList = [];
      videoList = videos;
    }

    var imgTags = imgList.map(function (url, idx) {
      var styleObj = {
        backgroundImage: "url(".concat(url, ")"),
        backgroundPosition: 'center center',
        paddingBottom: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display: 'inline-block',
        width: '100%'
      };
      var classColSize = 12;

      if (imgList.length === 4) {
        styleObj.paddingBottom = '50%';
      } else if (imgList.length === 2) {
        styleObj.paddingBottom = '50%';
      } else if (imgList.length === 3) {
        styleObj.paddingBottom = '50%';
      }

      if (imgList.length === 4) {
        if (idx === 0) {
          styleObj.borderTopLeftRadius = 16;
        } else if (idx === 1) {
          styleObj.borderTopRightRadius = 16;
        } else if (idx === 2) {
          styleObj.borderBottomLeftRadius = 16;
        } else if (idx === 3) {
          styleObj.borderBottomRightRadius = 16;
        }
      } else if (imgList.length === 3) {
        if (idx === 0) {
          styleObj.borderBottomLeftRadius = 16;
          styleObj.borderTopLeftRadius = 16;
          styleObj.height = '100%';
          styleObj.width = '100%';
        } else if (idx === 1) {
          styleObj.borderTopRightRadius = 16;
          styleObj.paddingRight = 0;
          styleObj.marginBottom = '1px';
          styleObj.height = '50%';
        } else if (idx === 2) {
          styleObj.borderBottomRightRadius = 16;
          styleObj.paddingRight = 0;
          styleObj.marginTop = '1px';
          styleObj.height = '50%';
        }
      } else if (imgList.length === 2) {
        if (idx === 0) {
          styleObj.borderTopLeftRadius = 16;
          styleObj.borderBottomLeftRadius = 16;
        } else if (idx === 1) {
          styleObj.borderTopRightRadius = 16;
          styleObj.borderBottomRightRadius = 16;
        }
      } else if (imgList.length === 1) {
        styleObj.borderRadius = 16;
      }

      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: classColSize ? "col-xs-".concat(classColSize) : null,
        style: styleObj
      });
    });
    var imgContainer3 = /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        height: '25vh'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6",
      style: {
        padding: 0,
        marginRight: '2px',
        marginBottom: '0px'
      }
    }, imgTags[0]), /*#__PURE__*/React.createElement("div", {
      className: "col-xs-6",
      style: {
        display: 'flex',
        flexDirection: 'column',
        padding: 0,
        height: '50%'
      }
    }, imgTags[1], imgTags[2]));
    var videoTags = videoList.map(function (url, idx) {
      return url.indexOf('blarplesnurf') === -1 || url.indexOf('blarplesnurf-staging') === -1 ? /*#__PURE__*/React.createElement(Video, {
        src: url,
        key: idx,
        style: {
          borderRadius: 10,
          width: '100%',
          height: '100%'
        },
        autoPlay: true,
        loop: true,
        controls: true,
        muted: true
      }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, "Your video is being processed. One moment..."), /*#__PURE__*/React.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }));
    });
    return /*#__PURE__*/React.createElement("div", {
      className: styles.twitter_preview
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.tw_profile
    }, /*#__PURE__*/React.createElement("img", {
      src: accountInfo.profileImage,
      style: {
        borderRadius: '50%'
      }
    }), /*#__PURE__*/React.createElement("h3", null, accountInfo.profileName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
      className: styles.tw_accountun
    }, accountInfo.profileUsername)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
      className: styles.tw_post
    }, /*#__PURE__*/React.createElement("span", {
      id: "test-tw-message"
    }, m), /*#__PURE__*/React.createElement("div", {
      className: imgTags && imgTags.length % 2 === 0 ? styles.img_container_even : styles.img_container,
      style: {
        boxShadow: 'none',
        marginBottom: '16px'
      }
    }, imgTags && imgTags.length === 3 ? imgContainer3 : imgTags, videoTags), /*#__PURE__*/React.createElement("time", {
      className: styles.tw_datetime
    }, postDate ? postDate.format('h:mm A [·] MMM DD[,] YYYY') : ''), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("img", {
      src: "https://likeabucket.s3.amazonaws.com/2ry0muv4wk_1467044229634.png"
    })));
  }

  var imageUrl = images && images.length > 0 ? images[0] : '';
  var source = link || '';

  if (source) {
    var url = new URL(source, {});
    source = url.hostname;
  }

  var imageSection = imageUrl ? /*#__PURE__*/React.createElement("div", {
    className: styles.tw_summary_image
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_summary_image_ctr
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_image_wrap,
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.tw_card_img,
    src: imageUrl
  })))) : null;
  var summaryStyleOverride = {};

  if (!imageUrl) {
    summaryStyleOverride.height = 'auto';
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.twitter_preview
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_profile
  }, /*#__PURE__*/React.createElement("img", {
    src: accountInfo.profileImage
  }), /*#__PURE__*/React.createElement("h3", null, accountInfo.profileName), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", {
    className: styles.tw_accountun
  }, accountInfo.profileUsername)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    className: styles.tw_post
  }, m, /*#__PURE__*/React.createElement("div", {
    className: styles.img_container,
    style: {
      boxShadow: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_summary,
    style: summaryStyleOverride
  }, imageSection, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_summary_content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.tw_summary_content_wrap
  }, /*#__PURE__*/React.createElement("h2", {
    className: styles.tw_summary_title
  }, linkTitle), /*#__PURE__*/React.createElement("p", {
    className: styles.tw_summary_desc
  }, linkDescription), /*#__PURE__*/React.createElement("a", {
    href: link,
    target: "_blank",
    style: {
      textDecoration: 'none'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.tw_summary_source
  }, source)))))), /*#__PURE__*/React.createElement("small", {
    className: styles.tw_datetime
  }, postDate ? postDate.format('h:mm A [-] D MMM YYYY') : ''), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("img", {
    src: "https://likeabucket.s3.amazonaws.com/2ry0muv4wk_1467044229634.png"
  })));
}

export default TwitterPreview;